import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const ViewGuardian = () => {
  const { id } = useParams(); // Fetch the student ID from the route params
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

 useEffect(() => {
  const fetchGuardians = async () => {
    try {
      const storedSessionId = localStorage.getItem("currentSessionId");

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/guardians/getGuardiansByStudentId/${id}`,
        {
          params: { sessionId: storedSessionId }, 
        }
      );

      setData(response.data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch guardians.");
      setLoading(false);
    }
  };

  fetchGuardians();
}, [id]);


  if (loading) return <div className="text-center text-gray-500 mt-10">Loading...</div>;
  if (error) return <div className="text-center text-red-500 mt-10">{error}</div>;

  return  (
    <div className="min-h-full bg-gradient-to-b from-blue-50 to-blue-100 p-6">
      <h1 className="text-4xl font-extrabold text-center text-gray-800 mb-8">Guardian Details</h1>
      <div className="max-w-6xl mx-auto bg-white shadow-2xl rounded-2xl p-8">
        {/* Student Name with View Button */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold text-gray-700">
            Student: {data.studentName}
          </h2>
          <button
            onClick={() => navigate(`/students/${id}`)} // Navigate to the student's detail page
            className="px-4 py-2 bg-blue-800 text-white rounded-lg hover:bg-blue-600 transition duration-200"
          >
            View Student
          </button>
        </div>
        <p className="text-gray-600 mb-8">
          Class: <span className="font-medium">{data.class} ({data.section})</span>
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.guardians.map((guardian, index) => (
            <div
              key={index}
              className="bg-gray-50 border-2 border-gray-200 rounded-lg shadow-lg overflow-hidden transform hover:shadow-2xl duration-300"
            >
              <div className="relative">
                <img
                  src={guardian.image || "https://via.placeholder.com/150"}
                  alt={guardian.name}
                  className="w-full h-72 object-cover rounded-t-lg"
                />
                <div className="absolute bottom-4 left-4 bg-gray-900 bg-opacity-50 text-white px-4 py-2 rounded-full">
                  <span className="font-semibold">{guardian.relation}</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-medium text-gray-800">{guardian.name}</h3>
                <p className="text-gray-600 mt-2">Phone: {guardian.phone}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ViewGuardian;
